<div class="action-container h-100 d-flex align-items-center" *appHasRole="['Admin', 'Manager']">
  <app-ag-action-icon-button
    iconClass="ic-edit-16"
    (action)="edit()"
  />
</div>
